import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import CheckboxButton from '@/components/CheckboxButton'
import Popover from '@/components/Popover'
import RadioButton from '@/components/RadioButton'
import Search from '@/componentsDS/Search/index'
import { useTradex } from '@/hooks/use-tradex/index'
import { feature, features as featureConstant } from '@/utils/feature-verifier'
import { isEmpty } from 'lodash'
import { useEffect, useRef, useState } from 'react'

const CustomDropdown = ({
	items,
	onChangeFunc,
	keyText="Organisations",
	value,
	type,
	disable,
	allSelected=false,
	togglecheck,
	dataTestId,
	isPackage = false,
	...customDropdownProps
}) => {

	const types = {
		radio: "radio",
		checkbox: "checkbox",
	}

	const [selections, setSelections] = useState([])
	const [toggleValue, setToggleValue] = useState(false)
	const [allSelect, setAllSelect] = useState(allSelected)

	const isTradex = useTradex();

	/*=================================================
		Filter Popup
	/================================================*/
	const [filterVisible, setFilterVisible] = useState(false)
	const referenceRef = useRef(null)
	const initialRender = useRef(true);


	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
		setFilterVisible(false)
	}

	useEffect(() => {
		if(allSelect){
			return setSelections(items)
		}
		return setSelections([])
	}, [allSelect])

	const [filterValue, setFilterValue] = useState("");
	const [filterArray, setFilterArray] = useState();

	useEffect(()=>{
		setFilterArray(items)
	},[items])

	useEffect(() => {
		if((value && !isEmpty(value))){
			if (items && items.length > 0){
				setFilterArray([...items].sort((a, b)=> {
					return (a.id !== value?.id) - (b.id !== value?.id);
				}))
			}

			setSelections(value)
		}

		if(value && isEmpty(value) && isPackage){
			setSelections(value)
		}

		if(value === null){
			setToggleValue(true)
			setAllSelect(true)
		}
	}, [value])

	useEffect(()=>{
		if (initialRender.current) {
			initialRender.current = false;
		} else {
			setFilterValue("")
			if(!toggleValue){
				return onChangeFunc(selections)
			}
			return onChangeFunc(null)
		}
	},[filterVisible])

	function handleChange({e,field}){
		if(type==="radio"){
			setSelections([field])
		}
		if(type==="checkbox"){
			const index = selections?.findIndex((selection) => selection.id === e.target.value)
			if(index===-1){
				setSelections([...selections,field])
			}
			if(index!==-1){
				setSelections(selections.filter((selection)=> selection.id !== e.target.value))
			}
		}
		if (feature(featureConstant.healthdex_features) && (!isTradex)) {
			setFilterVisible(false)
		}
	}

	const list = filterArray?.filter((field)=> field?.name.toLowerCase().includes(filterValue.toLowerCase()) ).map((field, index) => {
		return (
			<div className={type === "checkbox" ? "custom-dropdown__group__content__checkbox" : "custom-dropdown__group__content__radio"} key={field.id}>
				{type === types.radio && (
					<RadioButton
						name={field.name}
						check={selections[0]?.id === field?.id}
						value={field.id}
						submit={(e) => handleChange({e,field})}
						{...customDropdownProps}
					/>
				)}
				{type === types.checkbox && (
					<CheckboxButton
						disabled={toggleValue}
						name={field.name}
						check={selections?.findIndex((selection) => selection.id === field.id) !== -1}
						value={field.id}
						submit={(e) => handleChange({e,field})}
						{...customDropdownProps}
					/>
				)}
			</div>
		)
	})

	function handleAllChange(){
		if(type === types.checkbox){
			if(Array.isArray(selections) && selections?.length === items.length){
				setSelections([])
			}
			if(Array.isArray(selections) && selections.length !== items.length){
				setSelections(items)
			}
			setToggleValue(false)
		}
	}

	function checkPartial(){
		if(type === types.checkbox){
			if(Array.isArray(selections) && selections?.length === items.length){
				return true
			}
			if(Array.isArray(selections) && selections.length > 0){
				return "partial"
			}
			return false
		}
	}

	function countOrganisations(){
		if(value.length === items.length || value === null){
			return `All ${keyText} selected`
		}

		if(value.length === 1){
			return value[0].name
		}

		if(value.length > 1){
			return `${value.length} ${keyText} selected`
		}
	}

	return (
		<div className="custom-dropdown__select__group">
			<Popover visible={filterVisible} className="demo" display="block"
				options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
			>
				<Popover.Trigger>
					<div id="trigger-visiblity" data-testid={dataTestId ? dataTestId : "trigger-visiblity"} className="custom-dropdown__select__trigger" onClick={() => {
						if (!disable) {
							setFilterVisible(!filterVisible)
						}
					}}>
						{type === types.radio && (
							<span className={value && value[0]?.name ? "custom-dropdown__selections--selected" : "custom-dropdown__selections"}>
								{value && value[0]?.name ? value[0].name : `Select ${keyText}`}
							</span>
						)}
						{type === types.checkbox && (
							<>
								{Array.isArray(value) && (
									value.length > 0 ? (
										<span className="custom-dropdown__selections--selected">
											{countOrganisations()}
										</span>
									) : (
										<span className="custom-dropdown__selections">
											{`Select ${keyText}`}
										</span>
									)
								)}
								{value === null && (
									<span className="custom-dropdown__selections--selected">
										{`All ${keyText} selected`}
									</span>
								)}
							</>
						)}
						{!disable && (
							<IconChevronDown />
						)}
					</div>
				</Popover.Trigger>

				<Popover.Content>
					<div className="custom-dropdown__select__content" data-testid="custom-dropdown__select__content" ref={referenceRef} style={{width: 236}} >
						<div className="multiCheckboxSelect__group__content">
							<div className="multiCheckboxSelect__group__content__cols">
								<div className='custom-dropdown__input-search--margin-bottom'>
									<Search
										value={filterValue}
										placeholder={`Search ${keyText}`}
										onChange={(e) => setFilterValue(e?.target.value)}
										onCancel={() => setFilterValue('')}
										variant='filled'
									/>
								</div>
								{
									list?.length > 0 && (
										<>
											{
												type === "checkbox" && (
													<>
														<div className="custom-dropdown__group__content__checkbox--all">
															<CheckboxButton
																name={`All ${keyText}`}
																check={checkPartial()}
																value="All"
																onChange={() => handleAllChange()}
															/>
															{togglecheck && (
																<div className="custom-dropdown__group__content__checkbox--partial">
																	<CheckboxButton
																		name={`Include upcoming ${keyText}`}
																		check={toggleValue}
																		value={null}
																		onChange={() => {
																			setToggleValue(!toggleValue)
																			setSelections(items)
																		}}
																	/>
																</div>
															)}
														</div>
													</>
												)
											}

											{list}
										</>
									)
								}
								{
									list?.length === 0 && (
										<div className="custom-dropdown__empty">
											No {keyText} Found
										</div>
									)
								}
							</div>
						</div>
					</div>
				</Popover.Content>
			</Popover>
		</div>

	)
}

export default CustomDropdown
